import axios from "axios";
import {utilityServicesPath} from "../../Constants";

const restUrl = `${utilityServicesPath}/customers/pictures`;

export default class CustomerPicturesService {
    /** GET …/customers/pictures/by-textured/by-ids?ids=… → PictureDto[] */
    static async getTexturedByIds(ids) {
        const unique = [...new Set(
            (Array.isArray(ids) ? ids : [])
                .map((id) => Number(id))
                .filter((id) => Number.isFinite(id) && id !== 0),
        )];
        if (unique.length === 0) {
            return {data: []};
        }
        return axios.get(`${restUrl}/by-textured/by-ids`, {
            params: {ids: unique},
            paramsSerializer: {indexes: null},
            headers: {
                Accept: 'application/json',
            },
        });
    }
}
